import React from 'react';
import { Skeleton } from '../../components/ui/skeleton';
import './ClientSkeleton.scss';

const ClientSkeleton = () => (
  <div className="client-skeleton">
    <div className="client-skeleton__page-header">
      <div className="client-skeleton__page-header-text">
        <Skeleton className="client-skeleton__page-title" />
        <Skeleton className="client-skeleton__page-subtitle" />
      </div>
      <Skeleton className="client-skeleton__page-action" />
    </div>

    <div className="client-skeleton__section client-skeleton__section--networks">
      <div className="client-skeleton__section-header">
        <Skeleton className="client-skeleton__heading" />
        <Skeleton className="client-skeleton__subheading" />
      </div>
      <div className="client-skeleton__card-grid client-skeleton__card-grid--networks">
        {Array.from({ length: 3 }).map((_, index) => (
          <div key={`network-${index}`} className="client-skeleton__card">
            <div className="client-skeleton__card-header">
              <Skeleton className="client-skeleton__icon" />
              <div className="client-skeleton__card-text">
                <Skeleton className="client-skeleton__card-title" />
                <Skeleton className="client-skeleton__card-subtitle" />
              </div>
              <Skeleton className="client-skeleton__status" />
            </div>
            <Skeleton className="client-skeleton__card-body" />
          </div>
        ))}
      </div>
    </div>

    <div className="client-skeleton__section">
      <div className="client-skeleton__section-header">
        <Skeleton className="client-skeleton__heading" />
        <Skeleton className="client-skeleton__subheading" />
      </div>

      <div className="client-skeleton__form">
        <div className="client-skeleton__form-row">
          <Skeleton className="client-skeleton__label" />
          <Skeleton className="client-skeleton__input" />
          <Skeleton className="client-skeleton__label" />
          <Skeleton className="client-skeleton__input" />
        </div>
        <div className="client-skeleton__form-row">
          <Skeleton className="client-skeleton__label" />
          <Skeleton className="client-skeleton__input" />
          <Skeleton className="client-skeleton__label" />
          <Skeleton className="client-skeleton__input" />
        </div>
        <div className="client-skeleton__form-row">
          <Skeleton className="client-skeleton__label" />
          <Skeleton className="client-skeleton__input client-skeleton__input--wide" />
        </div>
        <div className="client-skeleton__form-row client-skeleton__form-row--textarea">
          <Skeleton className="client-skeleton__label" />
          <Skeleton className="client-skeleton__textarea" />
        </div>
        <div className="client-skeleton__collapse">
          <Skeleton className="client-skeleton__collapse-trigger" />
        </div>
      </div>
    </div>
  </div>
);

export default ClientSkeleton;
